import ApiService from './ApiService';

export default class PriceApi extends ApiService {
    constructor() {
        super('');
    }

    getPriceList(payload) {
        return this.get('system/prices', payload);
    }

    getPriceDetail(id) {
        return this.get(`system/prices/${id}`);
    }

    createPrice(payload) {
        return this.post('system/prices', payload);
    }

    updatePrice(data) {
        const { id, payload } = data;
        return this.put(`system/prices/${id}`, payload);
    }

    deletePrice(id) {
        return this.delete(`system/prices/${id}`);
    }

    getPriceListEnduser(payload) {
        return this.get('prices', payload);
    }
}
